import { render, staticRenderFns } from "./MemoryCard.vue?vue&type=template&id=1a4d301b&scoped=true&"
import script from "./MemoryCard.vue?vue&type=script&lang=js&"
export * from "./MemoryCard.vue?vue&type=script&lang=js&"
import style0 from "./MemoryCard.vue?vue&type=style&index=0&id=1a4d301b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d301b",
  null
  
)

export default component.exports